module.exports = __webpack_public_path__ + "static/media/tooltip-icon.6c110938.svg";